module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page022"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_1"
    }
  }, [_vm._v("VEGETABLE STOCK")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_2"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ouillon de ")]), _vm._v("L"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("égumes")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_3"
    }
  }, [_vm._v("TIME REQUIRED: "), _c('span', {
    staticClass: "page022_3a"
  }, [_vm._v("2 hours")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_4"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("tock is an")]), _vm._v(" essential ingredient, particularly for vegan cooking.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_5"
    }
  }, [_vm._v("1 kg assorted vegetables")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_6"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_6a"
    }
  }, [_c('span', {
    staticClass: "page022_6a"
  }, [_vm._v(" According to availability and preference, wash, clean and")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_7"
    }
  }, [_vm._v("(onions, carrots, celery,")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_8"
    }
  }, [_vm._v("coarsely chop the vegetables.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_9"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_9a"
    }
  }, [_c('span', {
    staticClass: "page022_9a"
  }, [_vm._v(" Combine with the water in a large pan. Bring to the boil, lower")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_10"
    }
  }, [_vm._v("fennel, etc.)")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_11"
    }
  }, [_vm._v("the heat, cover and simmer for about 2 hours.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_12"
    }
  }, [_vm._v("2 litres water")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_13"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "pagen"
  }, [_vm._v("asics")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page022_0"
    }
  }, [_vm._v("22")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6033a1b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_022.vue
// module id = 120
// module chunks = 0